import axios from 'axios';

export const Api = () => axios;